module.exports = __webpack_public_path__ + "img/img90.0c212a76.jpg";